// extracted by mini-css-extract-plugin
export var infoRow = "_sl-2";
export var labelContainer = "_sl-0";
export var rightInfo = "_sl-1";